import React, { useState, useEffect } from 'react';
import { Link } from 'gatsby';
import { Formik, Form, Field } from 'formik';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Button, LinkButton, buttonSkinData, buttonBtnTypeData } from '~button';
import { H6, H2, P } from '~typography';
import { FormInput } from '~form';
import { TransitionItem } from '~helpers';
import { AlertFeedback, alertPropTypes } from '~alert';
import FormContainer from './FormContainer';
import FieldContainer from './FieldContainer';
import FormSignError from './FormSignError';
import ForgotPasswordLinkContainer from './ForgotPasswordLinkContainer';
import FooterActions from './FooterActions';
import HeadingContainer from './HeadingContainer';
import formSignInSchema from '../schema/formSignInSchema';
import authPropTypes from '../prop-types/authPropTypes';

var FormSignIn = function FormSignIn(_ref) {
  var intl = _ref.intl,
      onSubmitSignIn = _ref.onSubmitSignIn,
      isLoading = _ref.isLoading,
      errorMessage = _ref.errorMessage,
      buttonSkin = _ref.buttonSkin,
      buttonBtnType = _ref.buttonBtnType,
      toRecoverPassword = _ref.toRecoverPassword,
      toSignUp = _ref.toSignUp,
      siteName = _ref.siteName,
      showHeading = _ref.showHeading,
      inProp = _ref.inProp,
      inPropFeedback = _ref.inPropFeedback,
      feedbackType = _ref.feedbackType,
      feedbackMessage = _ref.feedbackMessage;

  var _useState = useState(false),
      isDirty = _useState[0],
      setIsDirty = _useState[1];

  var _useState2 = useState(0),
      isSubmitted = _useState2[0],
      setIsSubmitted = _useState2[1];

  var _useState3 = useState(false),
      validateOnBlur = _useState3[0],
      setValidateOnBlur = _useState3[1];

  useEffect(function () {
    setValidateOnBlur(!!(isDirty && isSubmitted));
  }, [isDirty, isSubmitted]);

  var submitSignIn = function submitSignIn(values) {
    onSubmitSignIn(values);
  };

  var initialValues = {
    emailAddress: '',
    password: ''
  };
  var renderHeading = /*#__PURE__*/React.createElement(HeadingContainer, null, /*#__PURE__*/React.createElement(H2, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "auth.signIn.heading.title"
  })), /*#__PURE__*/React.createElement(P, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "auth.signIn.heading.content"
  })));
  return /*#__PURE__*/React.createElement(FormContainer, null, /*#__PURE__*/React.createElement(AlertFeedback, {
    inProp: inPropFeedback,
    alertType: feedbackType,
    alertMessage: feedbackMessage
  }), /*#__PURE__*/React.createElement(TransitionItem, {
    inProp: inProp,
    appear: true
  }, showHeading && renderHeading, /*#__PURE__*/React.createElement(Formik, {
    initialValues: initialValues,
    validationSchema: formSignInSchema,
    validateOnChange: false,
    validateOnBlur: validateOnBlur,
    onSubmit: function onSubmit(values) {
      submitSignIn(values);
    }
  }, function (_ref2) {
    var dirty = _ref2.dirty,
        submitCount = _ref2.submitCount;
    useEffect(function () {
      setIsSubmitted(submitCount);
      setIsDirty(dirty);
    }, [dirty, submitCount]);
    return /*#__PURE__*/React.createElement(Form, {
      noValidate: true
    }, /*#__PURE__*/React.createElement(FieldContainer, null, /*#__PURE__*/React.createElement(Field, {
      component: FormInput,
      label: intl.formatMessage({
        id: 'auth.emailAddress.label'
      }),
      name: "emailAddress",
      id: "emailAddress",
      type: "email",
      disabled: isLoading,
      required: true
    })), /*#__PURE__*/React.createElement(FieldContainer, null, /*#__PURE__*/React.createElement(Field, {
      component: FormInput,
      label: intl.formatMessage({
        id: 'auth.password.label'
      }),
      name: "password",
      id: "password",
      type: "password",
      disabled: isLoading,
      required: true
    })), /*#__PURE__*/React.createElement(Button, {
      skin: buttonSkin,
      btnType: buttonBtnType,
      block: true,
      type: "submit",
      loading: isLoading,
      loadingMessage: intl.formatMessage({
        id: 'auth.signIn.loading.label'
      })
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "auth.signIn.label"
    })), /*#__PURE__*/React.createElement(FormSignError, {
      errorMessage: errorMessage
    }));
  }), /*#__PURE__*/React.createElement(ForgotPasswordLinkContainer, null, /*#__PURE__*/React.createElement(LinkButton, {
    btnType: "link",
    size: "sm",
    to: toRecoverPassword
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "auth.forgotPassword.label"
  }))), /*#__PURE__*/React.createElement(FooterActions, null, /*#__PURE__*/React.createElement(H6, {
    color: "muted"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "auth.signIn.newToSite.label",
    values: {
      siteName: siteName
    }
  }), ' ', /*#__PURE__*/React.createElement(Link, {
    to: toSignUp
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "auth.signIn.joinNow.label"
  }))))));
};

FormSignIn.defaultProps = {
  isLoading: false,
  errorMessage: null,
  buttonSkin: 'primary',
  buttonBtnType: 'default',
  toRecoverPassword: '/recoverPassword',
  toSignUp: '/signUp',
  showHeading: true,
  inProp: false,
  inPropFeedback: false,
  feedbackType: undefined,
  feedbackMessage: undefined
};
export default injectIntl(FormSignIn);